import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import React, { FC, useMemo } from 'react'
import Avatar from 'react-avatar'
import { Badge } from 'react-bootstrap'
import ReactTimeAgo from 'react-time-ago'
import { SvgIcon, SvgType } from 'src/components/shared/SvgIcon/SvgIcon'
import { MessageType } from '../LiveQuestions'
import { StyledMessage } from './styled'

interface AdminQuestionCardProps {
  message: MessageType
  handleArchieved?: (message: MessageType) => void
  handleFeatured?: (message: MessageType) => void
  handleShow?: (message: MessageType) => void
}

export const AdminQuestionCard: FC<AdminQuestionCardProps> = ({ message, handleArchieved, handleFeatured, handleShow }) => {
  return useMemo(() => {
    return (
      <StyledMessage featured={message.featured}>
        <div className="mb-2">
          <div className="d-flex align-items-center">
            <div className="profile">
              <Avatar name={message.dbUser} size="30" round />
            </div>
            <div className="sender">
              <div className="name">
                <span>{message.dbUser.toLowerCase()}</span>
                {message.featured && (
                  <Badge variant="light" className="ml-2">
                    Pinned
                  </Badge>
                )}
                {message.archived && (
                  <Badge variant="secondary" className="ml-2">
                    Archived
                  </Badge>
                )}
              </div>
              <small className="d-block timestamp">{message.dbTimestamp && <ReactTimeAgo date={message.dbTimestamp} />}</small>
            </div>
          </div>
          <p className={`message $message.featured ? 'text-muted' : ''}`}>{message.dbMessage}</p>
        </div>
        <div className="review-container">
          <button
            title="Archive"
            className="iconBtn"
            onClick={() => {
              handleArchieved(message)
            }}
          >
            <SvgIcon type={SvgType.ARCHIVE} fill={message.featured ? 'white' : '#52585e'} />
          </button>

          <button
            title="Pin to top"
            className="iconBtn mr-2"
            onClick={() => {
              handleFeatured(message)
            }}
          >
            {message.featured ? <SvgIcon type={SvgType.PIN_X} fill="white" /> : <SvgIcon type={SvgType.PIN_PLUS} fill="#52585e" />}
          </button>

          <BootstrapSwitchButton
            checked={message.show}
            onlabel="Presented"
            offlabel="Hidden"
            onChange={(checked: boolean) => {
              handleShow(message)
            }}
            width={88}
            size="xs"
            onstyle="info"
            offstyle="outline-secondary"
          />
        </div>
      </StyledMessage>
    )
  }, [handleArchieved, handleFeatured, handleShow, message])
}

export default AdminQuestionCard
